import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Spinner from '../Spinner'; // Import your Spinner component
import $ from 'jquery';  // Import jQuery (if it's not already available)
import FormMasterCard from './FormMasterCard';
import 'jquery-confirm'; 
import api from '../../api/axiosInstance';
const FormMastersForApprover = () => {
    const [rejectedForms, setRejectedForms] = useState([]);
    const [approvedForms, setApprovedForms] = useState([]);
    const [waitingForApprovalForms, setWaitingForApprovalForms] = useState([]);
    var status;
    // const [expiredForms, setExpiredForms] = useState([]);
    const [loading, setLoading] = useState(true);

  const fetchFormMasters = async () => {
    try { 
      const response = await api.get('/FormMaster'); // Adjust the endpoint as needed
      setRejectedForms(response.data.rejectedForms);
      setApprovedForms(response.data.approvedForms);
      setWaitingForApprovalForms(response.data.waitingForApprovalForms);

      console.log("rejected"+rejectedForms ,response.data.rejectedForms);
      console.log("approved"+approvedForms ,response.data.approvedForms);
      console.log("waitingforapproval"+waitingForApprovalForms,response.data.waitingForApprovalForms);
      // setExpiredForms(response.data.expiredForms);
    } catch (error) {
      console.error("Error fetching form masters", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
      fetchFormMasters();
      
      // fetchFormCategoriesAndTypes();
    }, []);

    const handleUpdateFormMasterStatus = (formId,status) => {debugger;

      $.confirm({
        title: 'Confirm Action',
        content: (status===121440001 ) ?'Are you sure to Approve ?':'Are you sure to Reject ?',
        type: 'blue',
        buttons: {
          confirm: {
            text: 'Yes',
            btnClass: 'btn-blue',
            action: function () {debugger;
              const loggedInUser = JSON.parse(localStorage.getItem('user')); // Parse the string to object
              const loggedInUserId = loggedInUser.id; // Now you can access the id
              var approvedOn =new Date();
              if(status===121440001){
                approvedOn =  new Date();
              }
           // or any other date
const isoDate = approvedOn.toISOString(); // This will format the date as "YYYY-MM-DDTHH:mm:ss.sssZ"
               // Modify the URL to pass 'recordGuid' and 'modifiedBy' as query parameters
            api.put(`/FormMaster/UpdateFormMasterStatus?recordGuid=${formId}&modifiedBy=${loggedInUserId}&status=${status}&approvedOn=${isoDate}`)
            .then(response => {
              $.alert({
                title: 'Success',
                content: response.data.message || "Form Master Updated successfully",
                type: 'green'
              });
             
                // Refresh form masters after activation
                fetchFormMasters(); // Refresh the data after activation
              })
              .catch((error) => {
                console.error("Error activating form master", error);
                $.alert({
                  title: 'Error',
                  content: 'Failed to activate the Form Master.',
                  type: 'red'
                });
              });
            }
          },
          cancel: {
            text: 'No',
            btnClass: 'btn-default',
          }
        }
      });
    };
  return (
    <div>
      {loading ? (
        <Spinner />
      ) : (
        <>
          
         <FormMasterCard
            title="Waiting For Approval Forms"
            sortedFormMasters={waitingForApprovalForms}
            handleUpdateFormMasterStatus={ (formId,status) => handleUpdateFormMasterStatus(formId, status)}
            // handleApprove={handleApprove} // Pass handleActivate to FormCard
            // handleExpiryDate={handleExpiryDate}
            // handleSetPublished={handleSetPublished}
            // copyFormMaster={copyFormMaster}
          />
          
          <FormMasterCard
            title="Approved Forms"
            sortedFormMasters={approvedForms}
            handleUpdateFormMasterStatus={ (formId,status) => handleUpdateFormMasterStatus(formId,status)}
            // handleApprove={handleApprove} // Pass handleActivate to FormCard
            // handleExpiryDate={handleExpiryDate}
            // handleSetPublished={handleSetPublished}
            // copyFormMaster={copyFormMaster}
          />
          <FormMasterCard
            title="Rejected Forms"
            sortedFormMasters={rejectedForms}
            handleUpdateFormMasterStatus={ (formId,status) => handleUpdateFormMasterStatus(formId, status)}
            // handleApprove={handleApprove} // Pass handleActivate to FormCard
            // handleExpiryDate={handleExpiryDate}
            // handleSetPublished={handleSetPublished}
            // copyFormMaster={copyFormMaster}
          />
         
        </>
      )}
    </div>
  );
};

export default FormMastersForApprover;
